const cfg = window.SparkleCartConfig || {};

// Cache DOM selectors for better performance
const DOM = {
    cartDrawer: document.getElementById("cartDrawer"),
    cartDrawerWrapper: document.getElementById("cartDrawer-inner__wrapper"),
    cartDrawerTitle: document.querySelector(".cart-drawer__title span"),
    cartDrawerTotalPrice: document.getElementById("cartDrawerTotalPrice"),
    cartDrawerOriginalTotalPrice: document.getElementById("cartDrawerOriginalTotalPrice"),
    ajaxCart: document.getElementById("ajaxCart"),
    sizeNotes: document.querySelectorAll(".js-cart-drawer-size-notice"),
    headerIconsQty: document.querySelectorAll(".header-icons_qty"),
    shippingFill: document.getElementById("shipping-fill_ajax"),
    shippingLabel: document.getElementById("shipping_label"),
    body: document.body
};

function refreshCartDrawerDOM() {
    DOM.cartDrawer = document.getElementById("cartDrawer");
    DOM.cartDrawerWrapper = document.getElementById("cartDrawer-inner__wrapper");
    DOM.cartDrawerTitle = document.querySelector(".cart-drawer__title span");
    DOM.cartDrawerTotalPrice = document.getElementById("cartDrawerTotalPrice");
    DOM.cartDrawerOriginalTotalPrice = document.getElementById("cartDrawerOriginalTotalPrice");
    DOM.ajaxCart = document.getElementById("ajaxCart");
    DOM.sizeNotes = document.querySelectorAll(".js-cart-drawer-size-notice");
    DOM.headerIconsQty = document.querySelectorAll(".header-icons_qty");
    DOM.shippingFill = document.getElementById("shipping-fill_ajax");
    DOM.shippingLabel = document.getElementById("shipping_label");
    DOM.body = document.body;
}

const STEP_CONDITIONS = {
    default_text: 'Add Products',
    step_one_condition: parseFloat(cfg.stepOneCondition || 0),
    step_one_text: cfg.stepOneText || '',
    step_two_condition: parseFloat(cfg.stepTwoCondition || 0),
    step_two_text: cfg.stepTwoText || '',
    step_three_condition: parseFloat(cfg.stepThreeCondition || 0),
    step_three_text: cfg.stepThreeText || '',
    step_four_condition: parseFloat(cfg.stepFourCondition || 0),
    step_four_text: cfg.stepFourText || '',
    step_five_condition: parseFloat(cfg.stepFiveCondition || 0),
    step_five_text: cfg.stepFiveText || '',
    top_step_reached_message: cfg.topStepMessage || ''
};

// Fetch utilities
const fetchJSON = async (url, options = {}) => {
    try {
        const response = await fetch(url, options);
        return await response.json();
    } catch (error) {
        console.error(`Fetch error for ${url}:`, error);
        throw error;
    }
};

function getVariantCategory(label = '') {
    const value = label.toLowerCase();

    const matches = (keywords) => keywords.some((kw) => value.indexOf(kw) !== -1);

    if (matches(['adult', 'mom', 'mother', 'mama', 'dad', 'father', 'papa', 'men', 'wom', 'his', 'hers'])) {
        return 'adult';
    }
    if (matches(['baby', 'infant', 'newborn'])) {
        return 'baby';
    }
    if (matches(['child', 'kid', 'kids', 'youth', 'toddler', 'boy', 'girl', 'teen'])) {
        return 'child';
    }
    if (matches(['pet', 'dog', 'cat'])) {
        return 'pet';
    }

    return null;
}

function checkVariantsInCart(){
    const cartItemsMap = {};

    document.querySelectorAll('.js-cart-drawer-size-notice').forEach(function(element){
        const title = (element.getAttribute('title') || '').trim();
        const productId = element.getAttribute('attr');
        const property = element.getAttribute('property');
        
        if (!productId || !title || !property) return;

        if (!cartItemsMap[productId]) {
            cartItemsMap[productId] = {
                elements: [],
                hasAdult: false,
                hasChild: false,
                hasBaby: false,
            };
        }

        const category = getVariantCategory(title);

        if (category === 'adult') {
            cartItemsMap[productId].hasAdult = true;
        } else if (category === 'child') {
            cartItemsMap[productId].hasChild = true;
        } else if (category === 'baby') {
            cartItemsMap[productId].hasBaby = true;
            cartItemsMap[productId].hasChild = true; // babies count toward the child/baby pairing
        }

        cartItemsMap[productId].elements.push(element);
    });

    Object.keys(cartItemsMap).forEach(function(productId){
        const product = cartItemsMap[productId];
        let warning = '';

        if (product.hasAdult && !product.hasChild) {
            warning = 'You have not added any matching Child/Baby sizes!';
        } else if (!product.hasAdult && (product.hasChild || product.hasBaby)) {
            warning = 'You have not added any matching Adult sizes!';
        }

        if (warning) {
            product.elements.forEach(function(el){
                el.classList.remove('hidden');
                el.textContent = warning;
            });
        }
    });
}

function setCartDrawerOpen(isOpen) {
    const drawer = DOM.cartDrawer;
    if (!drawer) return;

    if (isOpen) {
        drawer.setAttribute("data-active", "");
        drawer.removeAttribute("aria-hidden");
    } else {
        drawer.removeAttribute("data-active");
        drawer.setAttribute("aria-hidden", "true");
    }

    document.querySelectorAll('[aria-controls="cartDrawer"]').forEach((el) => {
        el.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });

    DOM.body.classList.toggle("scroll-disabled", isOpen);
    DOM.body.classList.toggle("no-scroll", isOpen);

    const boostToolbar = document.querySelector(".boost-sd__toolbar-container");
    boostToolbar?.classList.toggle("cart-open", isOpen);
}

// Function to toggle cart visibility
function toggleCart() {
    getCartData();

    // Don't toggle if currently loading - let loading operations complete
    if (DOM.cartDrawer?.hasAttribute("data-loading")) {
        return;
    }

    const isOpen = !DOM.cartDrawer?.hasAttribute("data-active");
    setCartDrawerOpen(isOpen);
}

// Function to update shipping bar
function shippingBarUpdate(data){
    const shippingRate = cfg.shippingRate || 0;
    let shippingBarValue = data.total_price / 100;
    let shippingBarPercent = shippingBarValue / shippingRate * 100;
    let amountLeft = Math.round(shippingRate * 100) - data.total_price;
    if(data.total_discount != 0) {
        document.getElementById("cartDrawerOriginalTotalPrice").style.display = "flex";
        document.getElementById("cartDrawerTotalPrice").innerHTML = `$${(data.total_price/100).toFixed(2)}`;
        document.getElementById("cartDrawerOriginalTotalPrice").innerHTML = `$${(data.original_total_price/100).toFixed(2)}`;
    } else {
        document.getElementById("cartDrawerOriginalTotalPrice").style.display = "none";
        document.getElementById("cartDrawerTotalPrice").innerHTML = `$${(data.total_price/100).toFixed(2)}`;
        document.getElementById("cartDrawerOriginalTotalPrice").innerHTML = `$${(data.original_total_price/100).toFixed(2)}`;
    }
    if (shippingBarPercent < 100){
        document.getElementById("shipping-fill_ajax").style.width = `${shippingBarPercent}%`;
        document.getElementById("shipping_label").innerHTML = "You're " + ` $${(amountLeft/100).toFixed(2)}` + " away from Free Shipping!";
    } else {
        document.getElementById("shipping-fill_ajax").style.width = '100%';
        document.getElementById("shipping_label").innerHTML = "You got Free Shipping!"
    }
}

function getItemStrikethroughCents(item) {
    const compareAt = Number(
        (item.properties && item.properties._compare_at_price) ||
        (cfg.compareAtByVariant && cfg.compareAtByVariant[item.variant_id]) ||
        0
    );

    if (compareAt > item.final_price) {
        return compareAt;
    }

    if (item.original_price > item.final_price) {
        return item.original_price;
    }

    return null;
}

function syncCompareAtCacheFromSection(doc) {
    if (!cfg.compareAtByVariant) {
        cfg.compareAtByVariant = {};
    }

    doc.querySelectorAll('.cart-drawer__item[data-compare-at]').forEach(function(element) {
        const variantId = element.getAttribute('data-id');
        const compareAt = Number(element.getAttribute('data-compare-at') || 0);
        if (variantId) {
            cfg.compareAtByVariant[variantId] = compareAt;
        }
    });
}

function attachCartItemListeners() {
    document.querySelectorAll('.cart-drawer_item_remove').forEach(function(button) {
        button.addEventListener('click', removeCartItem);
    });
}

function refreshCartItemsFromSection(sectionHtml) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(sectionHtml, 'text/html');
    const newWrapper = doc.getElementById('cartDrawer-inner__wrapper');

    if (!newWrapper || !DOM.cartDrawerWrapper) {
        return false;
    }

    DOM.cartDrawerWrapper.innerHTML = newWrapper.innerHTML;
    syncCompareAtCacheFromSection(doc);
    attachCartItemListeners();
    return true;
}

// Function to create cart item element
function createCartItemElement(item) {
    const template = document.createElement('div');
    const currencySymbol = cfg.currencySymbol || '$';
    const strikethroughCents = getItemStrikethroughCents(item);

    const itemHTML = `
        <div class="cart-item-container ts:px-[12px] py-[20px] border-b border-[#E5E6E9]">
            <div class="cart-drawer__item flex items-start justify-between p-0 flex-wrap relative" data-id="${item.variant_id}" line-item-id="${item.variant_id}" id="${item.variant_id}" data-handle="${item.handle}" data-compare-at="${(cfg.compareAtByVariant && cfg.compareAtByVariant[item.variant_id]) || 0}">
                <p class="js-cart-drawer-size-notice w-full text-[12px] font-medium leading-normal tracking-[0.12px] text-white bg-[#F10F53] border-2 border-[#FF88A5] py-2 px-0 rounded text-center hidden mb-[15px]" attr="${item.product_id}" title="${getItemTitle(item)}" property="${getItemProperty(item)}"></p>
                <div class="cart-drawer__item_image flex w-full max-w-[80px] aspect-[80/115] overflow-hidden">
                    <a clas="block w-full h-full" href="${item.url}">
                        <img src="${item.featured_image.url}" class="lazyload w-full h-full object-cover rounded-sm border border-brand-xlight-grey">
                    </a>
                </div>
                <div class="cart-drawer_item_info flex flex-col w-[55%] max-w-none pt-[8px] gap-[8px]">
                    <a class="cart-item__name h4 break text-[12px] font-normal leading-[17px] tracking-[0.12px] text-left text-black" href="${item.url}">${item.product_title}</a>
                    ${getVariantInfo(item)}
                    ${getPropertyInfo(item)}
                    <div class="cart-drawer_item_qty flex flex-col items-left justify-center h-full gap-0">
                        <div class="item-qty-selector_wrapper min-h-[32px] flex items-center justify-between w-[78px] h-8 border border-[#F1F3F6] px-3 py-1 rounded-full gap-3" data-id="${item.variant_id}">
                            <span class="selector-icon select-minus text-2xl font-light cursor-pointer" data-id="${item.variant_id}" onclick="decreaseQty()">-</span>
                            <span class="cart-drawer_item_qty-selector text-[14px] p-0 m-0">${item.quantity}</span>
                            <span class="selector-icon select-plus text-2xl font-light cursor-pointer" data-id="${item.variant_id}" onclick="increaseQty()">+</span>
                        </div>
                        <button type="button" onclick="removeCartItem()" class="cart-drawer_item_remove text-base font-medium underline cursor-pointer absolute right-0" data-id="${item.variant_id}">
                            <span class="sr-only">Remove item</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" class="pointer-events-none">
                                <g clip-path="url(#clip0_604_1706)">
                                <path d="M14.5 11.5H17.5M11.5 13H20.5M19.5 13L19.1494 18.2596C19.0967 19.0488 19.0704 19.4433 18.9 19.7425C18.75 20.0059 18.5236 20.2176 18.2508 20.3498C17.941 20.5 17.5455 20.5 16.7547 20.5H15.2453C14.4545 20.5 14.059 20.5 13.7492 20.3498C13.4764 20.2176 13.25 20.0059 13.1 19.7425C12.9296 19.4433 12.9033 19.0488 12.8506 18.2596L12.5 13M15 15.25V17.75M17 15.25V17.75" stroke="black" stroke-width="1.38462" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#F1F3F6"/>
                                <defs>
                                <clipPath id="clip0_604_1706">
                                <rect width="12" height="12" fill="white" transform="translate(10 10)"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>
                </div>
                <div class="cart-drawer_item_price pt-[8px] flex flex-col">
                    ${strikethroughCents ? `
                        <span class="visually-hidden">Regular price</span>
                        <s class="text-[12px] leading-[17px] tracking-[0.12px] text-[#8A8A93] font-semibold line-through">
                            ${currencySymbol} ${(strikethroughCents / 100).toFixed(2)}
                        </s>
                    ` : ''}
                    <span class="text-[12px] leading-[17px] tracking-[0.12px] font-semibold">
                        ${currencySymbol} ${(item.final_price / 100).toFixed(2)}
                    </span>
                </div>
            </div>
        </div>
    `;
    
    template.innerHTML = itemHTML;
    return template.firstElementChild;
}

// Helper functions for cart item creation
function getItemTitle(item) {
    if (item.variant_title !== null) {
        for (let i = 0; i < item.options_with_values.length; i++) {
            if (item.options_with_values[i].name.toLowerCase().includes('size')) {
                return item.options_with_values[i].value;
            }
        }
    }
    return "";
}

function getItemProperty(item) {
    return item.properties && item.properties.Type ? item.properties.Type : "";
}

function getVariantInfo(item) {
    if (item.variant_title !== null) {
        let variantInfo = '';
        if (item.price > item.discounted_price && item.discounts[0]?.title) {
            variantInfo += `<span class="discountMsg max-w-max text-[12px] font-normal bg-[#ECA7BB] p-2">${item.discounts[0]?.title}</span>`;
        }
        for (let i = 0; i < item.options_with_values.length; i++) {
            const namec = item.options_with_values[i].name;
            const valuec = item.options_with_values[i].value;
            if (namec.indexOf('Title') === -1) {
                variantInfo += `<span class="item_info-variant text-[12px] text-[#555] font-normal leading-5 tracking-[0.12px] text-left mb-[12px]">${namec}: ${valuec}</span>`;
            }
        }
        return variantInfo;
    }
    return "";
}

function getPropertyInfo(item) {
    if (!item.properties) return "";

    const propertyItems = Object.entries(item.properties)
        .filter(([key, value]) => {
            if (!value || String(value).trim() === "") return false;
            if (key.includes("checkoutblocks")) return false;
            if (key.includes("Type")) return false;
            if (key.startsWith("_")) return false;
            return true;
        })
        .map(([key, value]) => {
            const label = key === "Embroidery" ? "Name" : key;
            const displayValue = String(value).includes("/uploads/")
                ? `<a class="lightbox" href="${value}">Uploaded file</a>`
                : value;
            return `<li class="text-[12px] text-brand-dark-grey leading-5 tracking-[0.12px] text-left">${label}: ${displayValue}</li>`;
        });

    if (propertyItems.length === 0) return "";

    return `<ul class="lineitem_property mb-[6px] grid gap-y-[8px]">${propertyItems.join("")}</ul>`;
}

// Function to update cart drawer with latest data
function cartDrawerUpdate(data, options = {}) {
    refreshCartDrawerDOM();
    
    DOM.cartDrawerTitle.innerHTML = " (" + data.item_count + ")";
    
    if (!options.skipRebuild) {
        rebuildCartItems(data);
    }

    
    if (data.total_discount !== 0) {
        DOM.cartDrawerOriginalTotalPrice.style.visibility = "visible";
    } else {
        DOM.cartDrawerOriginalTotalPrice.style.visibility = "hidden";
    }
    
    DOM.cartDrawerTotalPrice.innerHTML = `$${(data.total_price / 100).toFixed(2)}`;
    DOM.cartDrawerOriginalTotalPrice.innerHTML = `$${(data.original_total_price / 100).toFixed(2)}`;
    
    const shippingBar = document.getElementsByClassName('cart-drawer__free-shipping');
    if (shippingBar.length > 0) {
        shippingBarUpdate(data);
    }
    
    updateDiscountSteps(data);
    
    if (DOM.cartDrawer.hasAttribute("data-active")) {
        setCartDrawerOpen(true);
    }
}

// Function to completely rebuild cart items
function rebuildCartItems(data) {
    DOM.cartDrawerWrapper.innerHTML = "";
    
    const fragment = document.createDocumentFragment();
    data.items.forEach(item => {
        const cartItemElement = createCartItemElement(item);
        fragment.appendChild(cartItemElement);
    });
    
    DOM.cartDrawerWrapper.appendChild(fragment);
    
    attachCartItemListeners();
}

// Function to update existing cart items
function updateExistingCartItems(data) {
    const currencySymbol = cfg.currencySymbol || '$';

    document.querySelectorAll('.cart-drawer__item .discountMsg').forEach(msg => {
        msg.remove();
    });
    for (let i = 0; i < data.items.length; i++) {
        const itemPriceElement = document.getElementsByClassName('item_price')[i];
        const qtyElement = document.getElementsByClassName('cart-drawer_item_qty-selector')[i];
        const cartItem = document.getElementsByClassName('cart-drawer__item')[i];
        const itemNameElement = document.getElementsByClassName('cart-item__name')[i];
        if (itemPriceElement) {
            itemPriceElement.innerHTML = `${currencySymbol} ${(data.items[i].price / 100).toFixed(2)}`;
        }
        if (qtyElement) {
            qtyElement.innerHTML = data.items[i].quantity;
        }
        if (data.items[i].price > data.items[i].discounted_price) {
            if (itemPriceElement) {
                itemPriceElement.innerHTML = `${currencySymbol} ${(data.items[i].discounted_price / 100).toFixed(2)}`;
            }
            if (data.items[i].discounts && data.items[i].discounts[0]?.title) {
                if (cartItem && !cartItem.querySelector(".discountMsg") && itemNameElement) {
                    const discountMsg = document.createElement("span");
                    discountMsg.className = "discountMsg max-w-max text-[12px] font-normal bg-[#ECA7BB] p-2";
                    discountMsg.innerHTML = data.items[i].discounts[0]?.title;
                    itemNameElement.after(discountMsg);
                }
            }
        }
    }
}

// Function to analyze cart data for discount logic
function analyzeCartData(data) {
    let cartTotal = data.total_price / 100;
    
    let noOfFreeProd = 0;
    let mysteryFlag = false;
    let mysteryitem = {};
    let totalMysteryProducts = 0;
    let nonFreetotalMysteryProducts = 0;
    let partialFreeProducts = {};
    let nonMysteryProductTotal = 0;
    const progressStepsItemsCount = document.querySelectorAll(".progress_steps-item").length;
    
    data.items.forEach(item => {
        if (item.total_discount != 0) {
            noOfFreeProd += item.quantity;
        }
        
        if (item.product_title.includes("Mystery")) {
            totalMysteryProducts += item.quantity;
            mysteryFlag = true;
            
            if (item.total_discount == 0) {
                nonFreetotalMysteryProducts += item.quantity;
            }
            
            if (item.total_discount == 0) {
                mysteryitem = item;
            }
            
            if (item.original_line_price > item.final_line_price && item.final_price != 0) {
                partialFreeProducts = item;
            }
        } else {
            nonMysteryProductTotal += (item.final_line_price / 100);
        }
    });
    
    if (totalMysteryProducts >= 1) {
        let get_lineitem_price = mysteryitem.price ? mysteryitem.price / 100 : 0;
        
        if (totalMysteryProducts == 1 && nonMysteryProductTotal > STEP_CONDITIONS.step_one_condition) {
            if (get_lineitem_price) {
                cartTotal += get_lineitem_price;
            }
        }
        
        if (get_lineitem_price) {
            cartTotal -= get_lineitem_price;
        }
        
        let partialProductPrice = partialFreeProducts.original_line_price ?
            (partialFreeProducts.original_line_price - partialFreeProducts.final_line_price) / 100 : 0;
        
        if (partialProductPrice) {
            cartTotal -= partialProductPrice;
        }
    }
    
    let conditions = {
        first: false,
        second: false,
        third: false,
        fourth: false,
        spentAmount: cartTotal,
        freeProductCount: noOfFreeProd,
        hasMysteryProducts: totalMysteryProducts >= 1
    };
    
    if (conditions.hasMysteryProducts) {
        if (cartTotal > STEP_CONDITIONS.step_four_condition || noOfFreeProd == 4) {
            conditions.fourth = true;
        } else if (cartTotal > STEP_CONDITIONS.step_three_condition || noOfFreeProd == 3) {
            conditions.third = true;
        } else if (cartTotal > STEP_CONDITIONS.step_two_condition || noOfFreeProd == 2) {
            conditions.second = true;
        } else if (cartTotal > STEP_CONDITIONS.step_one_condition || noOfFreeProd == 1) {
            conditions.first = true;
        }
    } else {
        if (cartTotal > STEP_CONDITIONS.step_four_condition && progressStepsItemsCount >= 4) {
            conditions.fourth = true;
        } else if (cartTotal > STEP_CONDITIONS.step_three_condition && progressStepsItemsCount >= 3) {
            conditions.third = true;
        } else if (cartTotal > STEP_CONDITIONS.step_two_condition && progressStepsItemsCount >= 2) {
            conditions.second = true;
        } else if (cartTotal > STEP_CONDITIONS.step_one_condition && progressStepsItemsCount >= 1) {
            conditions.first = true;
        }
    }
    
    return conditions;
}

// Function to update discount steps UI
function updateDiscountSteps(data) {
    const isStepBar = document.getElementsByClassName('get-discount-bar');
    if (isStepBar.length === 0) return;
    
    const conditions = analyzeCartData(data);

    setTimeout(() => {
        if (conditions.first) {
            updateUIForCondition(1, conditions.spentAmount);
        } else if (conditions.second) {
            updateUIForCondition(2, conditions.spentAmount);
        } else if (conditions.third) {
            updateUIForCondition(3, conditions.spentAmount);
        } else if (conditions.fourth) {
            updateUIForCondition(4, conditions.spentAmount);
        } else {                
            updateUIForCondition(0, conditions.spentAmount);
        }
    }, 100);
}

// Helper function for condition-specific UI updates
function updateUIForCondition(conditionLevel, spentAmount) {
    const progressStepsItems = document.querySelectorAll(".progress_steps-item");
    const addProductText = document.querySelector(".add-product .text");
    const firstOffText = document.querySelector(".first-off .text");
    const dashBar = document.querySelector(".dash-bar");
    const discountBarCountItem = document.querySelector(".get-discount-bar .count_item");
    const discountBarPercentCount = document.querySelector(".get-discount-bar .percent_count");
    const qualificationMsg = document.querySelector(".get-discount-bar .qualification_msg");
    const discountMsg = document.querySelector(".get-discount-bar .discount_msg");
    
    const firstOffSvgs = document.querySelectorAll(".first-off svg");
    const firstOffRects = document.querySelectorAll(".first-off svg rect");
    const addProductSvgs = document.querySelectorAll(".add-product svg");
    const addProductRects = document.querySelectorAll(".add-product svg rect");
    
    let titleElement, nextTitleElement, nextStepCondition;
    let activeSteps = [];
    
    switch(conditionLevel) {
        case 0:
            titleElement = STEP_CONDITIONS.default_text;
            nextTitleElement = STEP_CONDITIONS.step_one_text;
            nextStepCondition = STEP_CONDITIONS.step_one_condition;
            activeSteps = [];
            break;
        case 1:
            titleElement = STEP_CONDITIONS.step_one_text;
            nextTitleElement = STEP_CONDITIONS.step_two_text;
            nextStepCondition = STEP_CONDITIONS.step_two_condition;
            activeSteps = ["1"];
            break;
        case 2:
            titleElement = STEP_CONDITIONS.step_two_text;
            nextTitleElement = STEP_CONDITIONS.step_three_text;
            nextStepCondition = STEP_CONDITIONS.step_three_condition;
            activeSteps = ["1", "2"];
            break;
        case 3:
            titleElement = STEP_CONDITIONS.step_three_text;
            nextTitleElement = STEP_CONDITIONS.step_four_text;
            nextStepCondition = STEP_CONDITIONS.step_four_condition;
            activeSteps = ["1", "2", "3"];
            break;
        case 4:
            titleElement = STEP_CONDITIONS.step_four_text;
            nextTitleElement = STEP_CONDITIONS.top_step_reached_message;
            activeSteps = ["1", "2", "3", "4", "5"];
            break;
    }
    
    addProductText.innerHTML = titleElement;
    
    if (conditionLevel === progressStepsItems.length) {
        discountBarCountItem.textContent = STEP_CONDITIONS.top_step_reached_message;
        qualificationMsg.textContent = STEP_CONDITIONS.top_step_reached_message;
        firstOffText.innerHTML = STEP_CONDITIONS.top_step_reached_message;
        qualificationMsg.style.display = "block";
        discountMsg.style.display = "none";
        dashBar.style.backgroundImage = "linear-gradient(to right, #F5A7BE 100%)";
        firstOffSvgs.forEach(svg => {
            svg.style.backgroundColor = "#F5A7BE";
        });
    } else {
        discountBarCountItem.textContent = (nextStepCondition - spentAmount).toFixed(2);
        discountBarPercentCount.textContent = nextTitleElement;
        firstOffText.innerHTML = nextTitleElement;
        qualificationMsg.style.display = "none";
        discountMsg.style.display = "block";
        dashBar.style.backgroundImage = "linear-gradient(to right, #F5A7BE 62%, #BEC1C6 50%)";   
        firstOffSvgs.forEach(svg => {
            svg.style.backgroundColor = "#fff";
        });
    }
    
    if (activeSteps.length > 0) {
        progressStepsItems.forEach(item => {
            item.classList.remove("active");
            const itemText = item.textContent.replace(/\s/g, '');
            if (activeSteps.includes(itemText)) {
                item.classList.add("active");
            }
        });
        addProductRects.forEach(rect => {
            rect.style.fill = "#F5A7BE";
        });
        addProductSvgs.forEach(svg => {
            svg.style.borderColor = "#F5A7BE";
            svg.style.backgroundColor = "#F5A7BE";
        });
    } else {
        addProductRects.forEach(rect => {
            rect.style.fill = "";
        });
        addProductSvgs.forEach(svg => {
            svg.style.borderColor = "";
            svg.style.backgroundColor = "";
        });
    }
}

// Function to increase item quantity
function increaseQty() {
    const productId = event.target.getAttribute("data-id");
    const currentQty = parseInt(event.target.parentElement.querySelector(".cart-drawer_item_qty-selector").innerHTML);
    const newQty = currentQty + 1;

    updateCartItemQuantity(productId, newQty);
}

// Function to decrease item quantity
function decreaseQty() {
    const productId = event.target.getAttribute("data-id");
    const currentQty = parseInt(event.target.nextElementSibling.innerHTML);
    const newQty = Math.max(currentQty - 1, 0);

    updateCartItemQuantity(productId, newQty);
}

// Common function for updating cart item quantity
async function updateCartItemQuantity(productId, newQty) {
    const wasOpen = DOM.cartDrawer?.hasAttribute("data-active");
    
    DOM.cartDrawer?.setAttribute("data-loading", "");
    
    try {
        await fetchJSON('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: productId,
                quantity: newQty
            })
        });
        
        await getCartData();
    } catch (error) {
        console.error('Error updating quantity:', error);
        if (newQty > 0) {
            alert("Oops! You're trying to add more than we have left in stock — this item's almost gone!");
        }
    } finally {
        DOM.cartDrawer?.removeAttribute("data-loading");
    }
}

// Function to remove item from cart
async function removeCartItem() {    
    try {
        DOM.cartDrawer?.setAttribute("data-loading", "");
        
        const id = event.target.dataset.id || null;
        
        if (id === null) {
            throw new Error('Item ID is required');
        }

        const removeItem = document.getElementById(id);
        if (removeItem) {
            removeItem.closest('.cart-item-container').remove();
        }
        
        await fetchJSON('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: id,
                quantity: 0
            })
        });
        
        await getCartData();
    } catch (error) {
        console.error('Error removing item:', error);
    } finally {
        DOM.cartDrawer?.removeAttribute("data-loading");
    }
}

// Function to get cart data
async function getCartData() {
    refreshCartDrawerDOM();
    try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const [data, sectionResponse] = await Promise.all([
            fetchJSON('/cart.js'),
            fetch(`${root}?section_id=cart-drawer`)
        ]);
        const sectionHtml = await sectionResponse.text();
        const itemsRefreshedFromSection = refreshCartItemsFromSection(sectionHtml);

        cartDrawerUpdate(data, { skipRebuild: itemsRefreshedFromSection });
        checkVariantsInCart();
        
        DOM.headerIconsQty.forEach(element => {
            element.innerHTML = data.item_count;
        });
        
        return data;
    } catch (error) {
        console.error("GET Request failed: ", error);
        throw error;
    }
}

// Event listeners and initialization
document.addEventListener('DOMContentLoaded', function() {
    Object.assign(DOM, {
        continueShoppingBtn: document.querySelector(".continue-shopping"),
        cartDrawerCloseBtn: document.querySelector(".cart-drawer_close"),
    });
    
    DOM.continueShoppingBtn?.addEventListener('click', function(e) {
        e.preventDefault();
        toggleCart();
    });
    
    checkVariantsInCart();
    
    fetchJSON('/cart.js')
    .then(cart => {
        DOM.headerIconsQty.forEach(element => {
            element.innerHTML = cart.item_count;
        });
        
        if (DOM.cartDrawerTitle) {
            DOM.cartDrawerTitle.innerHTML = " (" + cart.item_count + ")";
        }
    })
    .catch(error => console.error("Initial cart load failed:", error));
    
    DOM.ajaxCart?.addEventListener("click", function(event) {
        if (DOM.ajaxCart?.getAttribute("aria-controls") === "cartDrawer") {
            event.preventDefault();
        }
        toggleCart();
    });
    
    DOM.cartDrawerCloseBtn?.addEventListener('click', function() {
        toggleCart();
    });
    
    document.addEventListener('click', function(event) {
        if (event.target.classList.contains('close_behind')) {
            toggleCart();
        }
    });
    
    document.addEventListener('cart:item-added', async function(event) {
        const shouldOpenDrawer = event.detail && event.detail.openDrawer;
        const wasOpen = DOM.cartDrawer?.hasAttribute("data-active");
        
        DOM.cartDrawer?.setAttribute("data-loading", "");
        
        try {
            await getCartData();
            
            if (shouldOpenDrawer || wasOpen) {
                setCartDrawerOpen(true);
            } else {
                setCartDrawerOpen(false);
            }
        } catch (error) {
            console.error('Error handling cart item added:', error);
            setCartDrawerOpen(wasOpen);
        } finally {
            DOM.cartDrawer?.removeAttribute("data-loading");
        }
    });
});

// Handle page show event (back button navigation)
window.onpageshow = function(event) {
    if (event.persisted) {
        getCartData()
            .catch(error => console.error("Error loading cart on page show:", error));
    }
};

// Handle back button on collection pages
if (document.body.classList.contains('template-collection')) {
    if (window.performance && window.performance.navigation.type === 2) {
        document.addEventListener('DOMContentLoaded', function() {
            getCartData()
                .catch(error => console.error("Error loading cart on collection page:", error));
        });
    }
}
